import { render, staticRenderFns } from "./sale-view-seller.vue?vue&type=template&id=4598efa4&scoped=true&"
import script from "./sale-view-seller.ts?vue&type=script&lang=ts&"
export * from "./sale-view-seller.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598efa4",
  null
  
)

export default component.exports